import {addLiveEventListener, scrollToTarget} from './utils';

export default class ScrollHandler {
	constructor(app) {
		this.app = app;
		const self = this;

		document.addEventListener('scroll', self.topButton);
		document.addEventListener('resize', self.topButton);
		self.topButton(null);

		this.autoScrollToAnchors();
	};

	/**
	 * Hide or show the go-to-top-button
	 * @param {Event} e The event
	 */
	topButton(e) {
		document.querySelector('.js-topbutton').classList.toggle(
			'is-scrolled',
			window.scrollY * 1.5 > window.innerHeight
		)
	}

	/**
	 * Scroll smooth to sections after clicking on anchor links.
	 */
	autoScrollToAnchors() {
		let offset = 155;
		addLiveEventListener(
			'click',
			'[href^="#"]:not([href^="#layer"]):not([href="#"]):not(.js-noscroll)',
			function (e) {
				e.preventDefault();

				const place = document.querySelector(this.getAttribute('href'));
				let tabPanel;

				if (place && (tabPanel = place.closest('sl-tab-panel')) !== null) {
					// if the target is inside a shoelace panel, open the panel first
					tabPanel.closest('sl-tab-group').show(tabPanel.name);
				}

				setTimeout(() => { // On the next tick, otherwise the panel ist not opened
					if (!(place && (place.getBoundingClientRect().top + window.scrollY))) {
						return;
					}

					// offset override for special elements
					if (this.dataset.scrollOffset) {
						offset = parseInt(this.dataset.scrollOffset);
					}

					scrollToTarget(place, -offset);
				}, 0)
			},
			document.body,
		);
	}
}
